import styled from 'styled-components';
import { getParameterFromURL } from '../../../../../../utils/scripts';
import chartImage from './img/graph.png';
import chartImageDark from './img/graphDark.png';

const darkTheme = getParameterFromURL('darkTheme') === 'true';

export const ChartImage = styled.img`
	margin-top: 27px;
	width: 100%;
	height: auto;
`;

ChartImage.defaultProps = {
	src: darkTheme ? chartImageDark : chartImage,
	alt: 'chart',
};
